import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { oneOneOneReactQueryKeys } from 'screens/oneOnOneRabbit/InstancePage/constants/oneOnOneReactQueryKeys';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { getOneOnOneRating, updateOneOnOneRating } from '../services';

export const useOneOnOneRatingQuery = ({ masterId, instanceId }: OneOnOneRequestI) =>
  useQuery(
    [oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId],
    () => getOneOnOneRating({ masterId, instanceId })
    // {
    //   enabled: !!masterId
    // }
  );

export const useOneOnOneRatingMutation = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ updatedRating }: { updatedRating: number }) =>
      await updateOneOnOneRating({
        masterId,
        instanceId,
        rating: updatedRating,
      }),
    onMutate: async ({ updatedRating }: { updatedRating: number }) => {
      await queryClient.cancelQueries([oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId]);
      const previousRating = queryClient.getQueryData([oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId]);
      queryClient.setQueryData([oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId], updatedRating);

      return { previousRating };
    },
    onError: (err, variables, context) => {
      if (context?.previousRating) {
        queryClient.setQueryData(
          [oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId],
          context.previousRating
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries([oneOneOneReactQueryKeys.oneOnOneRating, masterId, instanceId]);
    },
  });
};
